import React from 'react';
import classnames from 'classnames';
import { SmallUppercase } from 'scy/text';
import { flex } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function Toggle({
  value,
  options = [],
  name,
  onChange,
  className
}) {
  const selectedValue = value || options[0].value;

  return (
    <div className={classnames(flex, className)}>
      {options.map(option => {
        const id = [name, option.value].join('-');
        const isSelected = option.value === selectedValue;

        return (
          <SmallUppercase
            tag="label"
            className={classnames(styles.label, {
              [styles.unselectedLabel]: !isSelected,
              [styles.selectedLabel]: isSelected
            })}
            htmlFor={id}
            key={id}
          >
            <input
              type="radio"
              className={styles.input}
              id={id}
              name={name}
              value={option.value}
              onChange={() => onChange(option.value)}
            />
            {option.icon && (
              <span
                className={classnames(margin.right_xs, {
                  [styles.unselectedIcon]: !isSelected
                })}
              >
                {option.icon}
              </span>
            )}
            <span>{option.label}</span>
          </SmallUppercase>
        );
      })}
    </div>
  );
}
